const allowedEnvs = ['development', 'staging', 'production'] as const;
type AppEnv = (typeof allowedEnvs)[number];

const rawAppEnv = process.env.NEXT_PUBLIC_APP_ENV;
const appEnv: AppEnv = allowedEnvs.includes(rawAppEnv as AppEnv) ? (rawAppEnv as AppEnv) : 'development';

export const isDevelopment = appEnv === 'development';
export const isStaging = appEnv === 'staging';
export const isProduction = appEnv === 'production';

export { appEnv };
